module.exports = __webpack_public_path__ + "static/5-8f1f3472f60bdad16223b0a46736fd5b.png";